import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Cartoons(props: StickerArtProps) {
  return (
    <StickerFrame background="#dc2626" {...props}>
      <path d="M32 20 L24 11 M32 20 L40 11" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" />
      <rect x="12" y="20" width="40" height="29" rx="5" fill="#ffffff" />
      <rect x="16" y="24" width="32" height="21" rx="3" fill="#fde68a" />
      <circle cx="27" cy="31" r="2.5" fill="#1f2937" />
      <circle cx="37" cy="31" r="2.5" fill="#1f2937" />
      <path d="M25 37 Q32 43 39 37" fill="none" stroke="#1f2937" strokeWidth="2.5" strokeLinecap="round" />
    </StickerFrame>
  );
}
